'use client'

import { useEffect } from 'react'
import { criticalResourceLoader } from '@/lib/critical-resource-loader'

/**
 * Non-Critical Resource Loader
 * Loads non-critical CSS and resources after page load
 */
export default function NonCriticalResourceLoader() {
  useEffect(() => {
    // Load non-critical CSS asynchronously
    criticalResourceLoader.loadNonCriticalCSS()
    
    // Preload critical resources based on connection
    criticalResourceLoader.preloadCriticalResources()
    
    // Load additional resources based on user interaction
    const loadInteractionResources = () => {
      // Load resources needed for interactions
      const interactionResources = [
        '/styles/animations.css',
        '/styles/components.css'
      ]
      
      interactionResources.forEach(resource => {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = resource
        link.media = 'print'
        link.onload = () => {
          link.media = 'all'
        }
        document.head.appendChild(link)
      })
    }

    // Load interaction resources on first user interaction
    const events = ['mousedown', 'touchstart', 'keydown', 'scroll']
    const handleFirstInteraction = () => {
      loadInteractionResources()
      events.forEach(event => {
        document.removeEventListener(event, handleFirstInteraction, { passive: true })
      })
    }

    events.forEach(event => {
      document.addEventListener(event, handleFirstInteraction, { passive: true })
    })

    // Cleanup
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, handleFirstInteraction)
      })
    }
  }, [])

  return null
}